import axios, { AxiosError, AxiosRequestConfig, HeadersDefaults } from 'axios'
import store from '../hooks/store'
import Swal from 'sweetalert2'

interface CommonHeaderProperties extends HeadersDefaults {
	Authorization: string
}

const instance = axios.create({
	baseURL: process.env.REACT_APP_HOST,
	timeout: 10000,
})

export default instance

// 요청 인터셉터: 요청을 가로채서 캐싱 설정을 추가할 수 있음
instance.interceptors.request.use(
	(config: AxiosRequestConfig) => {
		// 여기서 config을 수정하여 캐싱 설정을 추가할 수 있음
		config.headers = config.headers ?? {} // 헤더가 없을 경우 빈 객체로 초기화
		config.headers['Cache-Control'] = 'no-cache' // 예시: 캐싱 비활성화
		return config
	},
	(error: AxiosError) => {
		return Promise.reject(error)
	}
)

instance.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config
		if (
			error.response &&
			// eslint-disable-next-line no-underscore-dangle
			!originalRequest._retry &&
			error.response.status === 400
		) {
			// badrequest
			Swal.fire({
				title: 'Error!',
				text: error?.response?.data?.data,
				icon: 'error',
				confirmButtonText: '확인',
			}).then((result) => {
				return
			})
			return Promise.reject(error)
		}
		return Promise.reject(error)
	}
)
